export default {
  namespaced: true,
  state: {
      isDark: localStorage.getItem('tema') === 'D'
  },
  getters: {
    IS_DARK: state => {
        return state.isDark
    }
  },
  mutations: {
    SET_IS_DARK: (state, payload) => {
        state.isDark = payload
    }
  },
  actions: {
    // só se quiser iniciar/forçar leitura novamente
    initFromStorage({ commit }) {
      const v = localStorage.getItem(STORAGE_KEY) === 'D'
      commit('SET_IS_DARK', v)
    },
    toggle({ commit, state }) {
      commit('SET_IS_DARK', !state.isDark)
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/tema-store.js